import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-LightItalicNew.woff2';
import woff from '../src/PPMori-LightItalicNew.woff';

export const ppMoriLightItalic: FontFaceSpec = {
  weight: 300,
  style: 'italic',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
